const ProgressRing: React.FC<{ percent: number }> = ({ percent }) => {
  const size = 266;
  const cx = 133;
  const cy = 133;
  const r = 113;
  const circ = 2 * Math.PI * r;
  const dashOffset = circ * (1 - percent / 100);
  const rotateDeg = (percent / 100) * 360 - 90 + 90;
  const marginPx = (15.0376 / 100) * size;

  return (
    <div className="relative w-full" style={{ aspectRatio: "1 / 1" }}>
      <svg viewBox={`0 0 ${size} ${size}`} className="w-full h-full block">
        <circle
          cx={cx}
          cy={cy}
          r={r}
          stroke="rgba(127,191,166,0.1)"
          strokeWidth="40"
          fill="none"
        />

        <circle cx={cx} cy={cy} r={r - 20} fill="white" />

        <circle
          cx={cx}
          cy={cy}
          r={r}
          stroke="#E5E9FA"
          strokeWidth="7"
          fill="none"
        />

        <circle
          cx={cx}
          cy={cy}
          r={r}
          stroke="#7D86A9"
          strokeWidth="7"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={dashOffset}
          style={{
            transform: "rotate(-90deg)",
            transformOrigin: "center",
            transition: "stroke-dashoffset 700ms ease-in-out",
          }}
        />

        <g
          style={{
            transform: `rotate(${rotateDeg}deg)`,
            transformOrigin: "center",
            transition: "transform 700ms ease-in-out",
          }}
        >
          <circle cx={cx} cy={20} r="8" fill="#7D86A9" />
        </g>
      </svg>

      <div
        className="absolute flex flex-col items-center justify-center text-center"
        style={{ inset: marginPx }}
      >
        <span className="font-bold leading-none text-dark-blue text-[40px] md:text-[50px] font-primary">
          {percent}%
        </span>
        <span className="mt-1 text-[13px] md:text-[18px] text-primary text-[#7d86a9]">
          Accomplished
        </span>
      </div>
    </div>
  );
};

export default ProgressRing;
